
import React, { useState,useEffect } from 'react';
import { Link ,useNavigate} from 'react-router-dom';
import { useAuth } from '../context/AuthContext'; 
import BackButton from "./BackButton";
import './MVProfile.css';

function MVProfile() {
  const { currentUser, logout } = useAuth(); 
  const navigate = useNavigate();
  const [isMenuOpen, setIsMenuOpen] = useState(false);
  const [isSidebarOpen, setIsSidebarOpen] = useState(false);
  const [openAccordion, setOpenAccordion] = useState({});


  const [searchParams, setSearchParams] = useState({
    keywords: '',
    location: '',
    category: '',
  });

  const handleSearchChange = (e) => {
    const { name, value } = e.target;
    setSearchParams((prev) => ({ ...prev, [name]: value }));
  };

  const handleSearchSubmit = (e) => {
    e.preventDefault();
    alert(`Searching for: Keywords: ${searchParams.keywords}, Location: ${searchParams.location}, Category: ${searchParams.category}`);
  };

  const handleLogout = async () => {
    try {
      await logout();
      
    } catch (error) {
      console.error('Logout error:', error);
      alert('Error during logout');
    }
  };

  const getUserInitial = () => {
    if (currentUser?.displayName) {
      return currentUser.displayName[0].toUpperCase();
    } else if (currentUser?.email) {
      return currentUser.email[0].toUpperCase();
    }
    return 'U';
  };
  const toggleAccordion = (key) => {
  setOpenAccordion((prev) => ({ ...prev, [key]: !prev[key] }));
};
useEffect(() => {
  if (isSidebarOpen) {
    document.body.classList.add('sidebar-open');
  } else {
    document.body.classList.remove('sidebar-open');
  }
}, [isSidebarOpen]);




  return (
    <div className="mv-profile-container">
<header className="nav-header">
        <nav className="nav-content">
          <div className="nav-left">
  <button className="back-btn" onClick={() => navigate(-1)}>←Back</button>
  <div className="nav-brand">
    <Link to="/">MV Profile</Link>
  </div>
</div>

          <ul className="nav-list">
            <li><Link to="/MHMV-profile/job-search">Find Jobs</Link></li>
            <li><Link to="/MHMV-profile/job-posting">Post a Free Job</Link></li>
            <li className="dropdown">
              <Link to="#" className="dropbtn">Courses</Link>
              <div className="dropdown-content">
                <Link to="/MHMV-profile/audio-courses/admin">Audio Courses</Link>
                <Link to="/MHMV-profile/video-course-home">Video Courses</Link>
              </div>
            </li>
            <li className="dropdown">
              <Link to="#" className="dropbtn">Services</Link>
              <div className="dropdown-content">
                <Link to="/android-dev">Android Development</Link>
                <Link to="/custom-software">Custom Software Development</Link>
                <Link to="/it-consulting">IT Consulting</Link>
                <Link to="/web-dev">Web Development</Link>
                <Link to="/mobile-app">Mobile Application Development</Link>
                <Link to="/training">Training</Link>
                <Link to="/career-dev">Career Development Coaching</Link>
                <Link to="/corporate-training">Corporate Training</Link>
                <Link to="/cloud-app">Cloud Application Development</Link>
              </div>
            </li>
            
            
            {!currentUser ? (
              
              <>
                <li><Link to="/MHMV-profile/jobseeker-login">Job Seeker Login</Link></li>
                <li><Link to="/MHMV-profile/employee-login">Employee Login</Link></li>
              </>
            ) : (
              
              <li className="dropdown">
                <Link to="#" className="dropbtn user-dropdown">
                  <div className="user-avatar-small">
                    {getUserInitial()}
                  </div>
                </Link>
                <div className="dropdown-content user-dropdown-content">
                  <Link to="/MHMV-profile/profile">View Profile</Link>
                  <Link to="/settings">Settings</Link>
                  <button onClick={handleLogout} className="logout-btn">Logout</button>
                </div>
              </li>
            )}
          </ul>
<button
  className="menu-toggle mobile-hamburger"
  onClick={() => setIsSidebarOpen(true)}
>
  ☰
</button>

        </nav>
      </header>
    
<div
  className={`mv-profile-container ${isSidebarOpen ? 'sidebar-open' : ''}`}
  onClick={() => setIsSidebarOpen(false)}
></div>

{/* Sidebar */}
<aside className={`offcanvas ${isSidebarOpen ? 'open' : ''}`}>
  <div className="offcanvas-header">
    <div className="profile-initial" onClick={() => { navigate('/MHMV-profile/profile'); setIsSidebarOpen(false); }}>
      {getUserInitial()}
    </div>
    <h3>Vero Disruptors</h3>
    <button className="offcanvas-close" onClick={() => setIsSidebarOpen(false)}>✕</button>
  </div>

  <ul className="offcanvas-list">
    <li><Link to="/MHMV-profile/job-search" onClick={() => setIsSidebarOpen(false)}>Find Jobs</Link></li>
    <li><Link to="/MHMV-profile/job-posting" onClick={() => setIsSidebarOpen(false)}>Post a Free Job</Link></li>

    <li>
      <div className="offcanvas-item" onClick={() => toggleAccordion('courses')}>
        <span>Courses</span>
        <span className={`chev ${openAccordion['courses'] ? 'open' : ''}`}>▶</span>
      </div>
      <div className={`offcanvas-submenu ${openAccordion['courses'] ? 'open' : ''}`}>
        <Link to="/MHMV-profile/audio-courses/admin" onClick={() => setIsSidebarOpen(false)}>Audio Courses</Link>
        <Link to="/MHMV-profile/upload-video-course" onClick={() => setIsSidebarOpen(false)}>Video Courses</Link>
      </div>
    </li>

    <li>
      <div className="offcanvas-item" onClick={() => toggleAccordion('services')}>
        <span>Services</span>
        <span className={`chev ${openAccordion['services'] ? 'open' : ''}`}>▶</span>
      </div>
      <div className={`offcanvas-submenu ${openAccordion['services'] ? 'open' : ''}`}>
        <Link to="/android-dev" onClick={() => setIsSidebarOpen(false)}>Android Development</Link>
        <Link to="/custom-software" onClick={() => setIsSidebarOpen(false)}>Custom Software</Link>
        <Link to="/it-consulting" onClick={() => setIsSidebarOpen(false)}>IT Consulting</Link>
        <Link to="/web-dev" onClick={() => setIsSidebarOpen(false)}>Web Development</Link>
        <Link to="/mobile-app" onClick={() => setIsSidebarOpen(false)}>Mobile App Development</Link>
        <Link to="/training" onClick={() => setIsSidebarOpen(false)}>Training</Link>
        <Link to="/career-dev" onClick={() => setIsSidebarOpen(false)}>Career Development</Link>
        <Link to="/corporate-training" onClick={() => setIsSidebarOpen(false)}>Corporate Training</Link>
        <Link to="/cloud-app" onClick={() => setIsSidebarOpen(false)}>Cloud Application</Link>
      </div>
    </li>

    {!currentUser ? (
      <>
        <li><Link to="/MHMV-profile/jobseeker-login" onClick={() => setIsSidebarOpen(false)}>Job Seeker Login</Link></li>
        <li><Link to="/MHMV-profile/employee-login" onClick={() => setIsSidebarOpen(false)}>Employee Login</Link></li>
      </>
    ) : (
      <>
        <li><Link to="/MHMV-profile/profile" onClick={() => setIsSidebarOpen(false)}>View Profile</Link></li>
        <li><Link to="/settings" onClick={() => setIsSidebarOpen(false)}>Settings</Link></li>
        <li><button onClick={handleLogout} className="logout-btn">Logout</button></li>
      </>
    )}
  </ul>
</aside>




     
      <div className="hero-section">
        <div className="hero-content">
          <h1>Find Your Dream Job with Vero Disruptors</h1>
          <p>Explore opportunities in AI, Data Science, and more.</p>
          <Link to="/MHMV-profile/job-search" className="hero-button">Explore Now</Link>
        </div>
      </div>

      
      <div className="search-section">
        <form onSubmit={handleSearchSubmit} className="search-form">
          <input
            type="text"
            name="keywords"
            placeholder="Keywords (e.g., AI Engineer)"
            value={searchParams.keywords}
            onChange={handleSearchChange}
          />
          <input
            type="text"
            name="location"
            placeholder="Location (e.g., Hyderabad)"
            value={searchParams.location}
            onChange={handleSearchChange}
          />
          <select
            name="category"
            value={searchParams.category}
            onChange={handleSearchChange}
          >
            <option value="">Select a Category</option>
            <option value="IT">IT</option>
            <option value="Marketing">Marketing</option>
            <option value="Finance">Finance</option>
            <option value="HR">HR</option>
            <option value="AI">AI/Data Science</option>
          </select>
          <button type="submit" className="search-button">Search</button>
        </form>
      </div>

     
      <div className="mv-profile-content">
        
        <section className="section who-we-are">
          <h2>Who We Are</h2>
          <p>Vero Disruptors is a forward-thinking startup dedicated to bringing innovative solutions to people and society.</p>
          
          <div className="who-we-are-content">
            <div className="who-we-are-text">
              <p>We focus on data science and AI applications across various domains, with special interest in AgriTech and EdTech. Our mission is to accelerate client success and positively impact society through responsible innovation.</p>
              <p>We provide end-to-end services from Android applications to Artificial Intelligence models, with a focus on sustainable domains like Food Tech, Green Energy, and Environmental Technology.</p>
              <p>At Vero Disruptors, we build reusable data science solutions and apps that automate complex daily activities. We also focus on data science talent development and help organizations find the right people.</p>
            </div>
            
            <div className="who-we-are-image">
              <img src="https://images.unsplash.com/photo-1522071820081-009f0129c71c?ixlib=rb-4.0.3&auto=format&fit=crop&w=1350&q=80" alt="Vero Disruptors Team" />
            </div>
          </div>
        </section>

        
        <section className="section">
          <h2>Our Mission</h2>
          <p>We are committed to driving innovation and creating positive impact through technology</p>
          
          <div className="mission-cards">
            <div className="mission-card">
              <div className="mission-icon">
                <i className="fas fa-bullseye"></i>
              </div>
              <h3>Innovate</h3>
              <p>Create cutting-edge solutions that address real-world challenges and transform industries.</p>
            </div>
            
            <div className="mission-card">
              <div className="mission-icon">
                <i className="fas fa-handshake"></i>
              </div>
              <h3>Collaborate</h3>
              <p>Work with clients and partners to develop tailored solutions that drive success.</p>
            </div>
            
            <div className="mission-card">
              <div className="mission-icon">
                <i className="fas fa-seedling"></i>
              </div>
              <h3>Sustain</h3>
              <p>Promote sustainable practices and develop solutions that benefit both people and planet.</p>
            </div>
          </div>
        </section>

       
        <section className="section">
          <h2>Our Values</h2>
          <p>The principles that guide everything we do at Vero Disruptors</p>
          
          <div className="values-grid">
            <div className="value-card">
              <div className="value-icon">
                <i className="fas fa-medal"></i>
              </div>
              <h3>Excellence</h3>
              <p>We strive for the highest quality in everything we do, delivering exceptional results for our clients.</p>
            </div>
            
            <div className="value-card">
              <div className="value-icon">
                <i className="fas fa-lightbulb"></i>
              </div>
              <h3>Innovation</h3>
              <p>We embrace new ideas and technologies to create solutions that make a difference.</p>
            </div>
            
            <div className="value-card">
              <div className="value-icon">
                <i className="fas fa-shield-alt"></i>
              </div>
              <h3>Integrity</h3>
              <p>We conduct our business with honesty, transparency, and ethical practices.</p>
            </div>
            
            <div className="value-card">
              <div className="value-icon">
                <i className="fas fa-hands-helping"></i>
              </div>
              <h3>Collaboration</h3>
              <p>We believe in the power of teamwork and partnerships to achieve great things.</p>
            </div>
          </div>
        </section>

        {/* What We Offer Section */}
        <section className="section">
          <h2>What We Offer</h2>
          <p>Comprehensive solutions tailored to your business needs</p>
          
          <div className="offer-cards">
            <div className="offer-card">
              <div className="offer-icon">
                <i className="fas fa-mobile-alt"></i>
              </div>
              <h3>Mobile Development</h3>
              <p>Custom Android and iOS applications with cutting-edge features and intuitive interfaces.</p>
            </div>
            
            <div className="offer-card">
              <div className="offer-icon">
                <i className="fas fa-brain"></i>
              </div>
              <h3>AI & Data Science</h3>
              <p>Advanced AI solutions and data-driven insights to transform your business operations.</p>
            </div>
            
            <div className="offer-card">
              <div className="offer-icon">
                <i className="fas fa-laptop-code"></i>
              </div>
              <h3>Web Development</h3>
              <p>Responsive, modern web applications that deliver exceptional user experiences.</p>
            </div>
            
            <div className="offer-card">
              <div className="offer-icon">
                <i className="fas fa-cloud"></i>
              </div>
              <h3>Cloud Solutions</h3>
              <p>Scalable cloud infrastructure and applications to support your business growth.</p>
            </div>
            
            <div className="offer-card">
              <div className="offer-icon">
                <i className="fas fa-chalkboard-teacher"></i>
              </div>
              <h3>Training & Coaching</h3>
              <p>Career development and corporate training programs to empower your team.</p>
            </div>
            
            <div className="offer-card">
              <div className="offer-icon">
                <i className="fas fa-handshake"></i>
              </div>
              <h3>IT Consulting</h3>
              <p>Strategic IT guidance to optimize your technology investments and digital transformation.</p>
            </div>
          </div>
        </section>

        {/* Testimonials Section */}
        <section className="section">
          <h2>What People Say About Us</h2>
          <p>Hear from our satisfied clients and partners</p>
          
          <div className="testimonials-grid">
            <div className="testimonial-card">
              <p className="testimonial-text">Vero Disruptors has transformed the way we approach data science. Their solutions are innovative and have significantly improved our operational efficiency.</p>
              <div className="testimonial-author">
                <div className="author-image"></div>
                <div className="author-info">
                  
                </div>
              </div>
            </div>
            
            <div className="testimonial-card">
              <p className="testimonial-text">The team at Vero Disruptors is highly skilled and professional. They delivered our mobile application ahead of schedule and beyond our expectations.</p>
              <div className="testimonial-author">
                <div className="author-image"></div>
                <div className="author-info">
                  
                </div>
              </div>
            </div>
            
            <div className="testimonial-card">
              <p className="testimonial-text">Their corporate training program completely transformed our team's capabilities. We've seen a dramatic improvement in our project delivery since working with Vero.</p>
              <div className="testimonial-author">
                <div className="author-image"></div>
                
              </div>
            </div>
          </div>
        </section>
        
      </div>
      

      <footer className="home-footer">
              <div className="container">
                <div className="home-footer-grid">
                  <div className="footer-section">
                    <h3>Vero Disruptors</h3>
                    <p>Driving innovation for a sustainable future through AI, data analytics, and talent development.</p>
                  </div>
                  
                  
      
                  
                  <div className="footer-section">
                    <h3>Contact</h3>
                    <p>Email: Venkatmor@verodisruptors.com</p>
                    <p>Phone: +91 9032584791</p>
                    <p>Location: Ongole, Andhra Pradesh</p>
                  </div>
                  <div className="footer-section">
                    <h3>Quick Links</h3>
                    <ul>
                      <li><Link to="/" className="home-footer-link">Home</Link></li>
                      <li><Link to="/mv-profile" className="home-footer-link">MV Profile</Link></li>
                      <li><Link to="/mv-agri" className="home-footer-link">MV Agri</Link></li>
                    </ul>
                  </div>
                </div>
                <div className="home-footer-bottom">
                  <p>&copy; 2025 Vero Disruptors Pvt Ltd. All rights reserved.</p>
                </div>
              </div>
            </footer>
    </div>
  );
}

export default MVProfile;